import type { RouteLocationNormalizedLoaded, Router } from 'vue-router';
import {
  AccountRouteName,
  AuthRouteName,
} from '@/js/account/app/router/route-names';
import { useAuthStore } from '@/js/account/entities/session';
import { resolveSafeRedirectPath } from '@/js/account/shared/lib';

export type NavigateAfterAuthResult =
  | 'navigated'
  | 'email-verification'
  | 'session-unavailable';

export async function navigateAfterAuth(
  router: Router,
  route: RouteLocationNormalizedLoaded,
): Promise<NavigateAfterAuthResult> {
  const authStore = useAuthStore();

  if (authStore.user) {
    const redirectPath = resolveSafeRedirectPath(route.query.redirect, '');

    if (redirectPath !== '') {
      await router.push(redirectPath);
    }
    else {
      await router.push({ name: AccountRouteName.Profile });
    }

    return 'navigated';
  }

  if (authStore.needsEmailVerification) {
    await router.push({ name: AuthRouteName.VerifyEmail });
    return 'email-verification';
  }

  return 'session-unavailable';
}
